import React from "react";

import { flexRender } from "@tanstack/react-table";
import { TableBody, TableRow, TableCell, Checkbox, cn } from 'twyne-new.ui';

import { useGrid } from '@Components/Grid/context';

import { useTableContext } from "./context";
import { TruncateWithTooltipFormatter } from "./formatters";

function DefaultTableBody() {
  const table = useTableContext()
  const { rows } = table.getRowModel()
  const { store: { loading } } = useGrid()

  return <TableBody className='overflow-x-auto'>
    <MemoizedTableBodyData rows={rows} loading={loading} />
  </TableBody>
}

function TableBodyData({ rows, loading }) {
  if (rows.length > 0) {
    return rows.map(({ id, getVisibleCells }, idx) => <TableRow key={id} className={idx % 2 && 'twy-bg-base'} >
      {/* <RowCheckbox id={id} original={original} /> */}
      {getVisibleCells().map(({ id, column, getContext }) => {
        const content = flexRender(column.columnDef.cell, getContext())

        return <TableCell key={id} className={cn('max-w-80', column.columnDef.initialSize)}>
          <TableBodyDataRow enableTruncateTooltip={column.columnDef.enableTruncateTooltip} enableTruncate={column.columnDef.enableTruncate} >
            {content}
          </TableBodyDataRow>
        </TableCell>
      })}
    </TableRow>)
  }

  if (!loading) {
    return <TableRow>
      <TableCell colSpan={100} className="text-center">
        No content to show.
      </TableCell>
    </TableRow>
  }

  return null
}

const TableBodyDataRow = ({ children, enableTruncateTooltip = false, enableTruncate = false }) => {
  if (enableTruncateTooltip) {
    return <TruncateWithTooltipFormatter value={children} />
  }
  return <div className={cn(enableTruncate && 'truncate')}>{children}</div>
}

const MemoizedTableBodyData = React.memo(TableBodyData, (prevProps, nextProps) => prevProps.rows === nextProps.rows && prevProps.loading === nextProps.loading)

function _RowCheckbox({ id, original }) {
  const rowId = original?.id ?? id
  const { rowsSelected, setRowsSelected } = useGrid()
  const isSelected = rowsSelected.includes(`${rowId}`)

  const handleSelectRow = (rowId, checkedValue) => {
    const checked = typeof checkedValue === 'boolean' ? checkedValue : !!checkedValue?.target?.checked

    setRowsSelected(prevRowsSelected => {
      const id = `${rowId}`
      if (checked) {
        if (prevRowsSelected.includes(id)) {
          return prevRowsSelected
        }
        return [...prevRowsSelected, id]
      }

      return prevRowsSelected.filter(selectedId => selectedId !== id)
    })
  }

  return <TableCell key={id}>
    <Checkbox value={isSelected} onChange={checked => handleSelectRow(rowId, checked)} />
  </TableCell>
}

export default React.memo(DefaultTableBody)
